import Box from "@mui/material/Box";
import { TextInput } from "react-admin";
import { CourseLesson } from "../../model/autovioCalendarEvents";
import { Row } from "../../misc/Row";
import { DateTimeInput } from "../../inputs/DateTimeInput";
import { Column } from "../../misc/Column";
import { SaveButton2 } from "../../buttons/SaveButton2";
import { LecturerInput } from "../../inputs/LecturerInput";
import { RoomInput } from "../../inputs/RoomInput";
import { EditForm2 } from "../../misc/EditForm2";
import * as React from "react";

interface EditCourseLessonFormProps {
  event: CourseLesson;
  closeDialog: () => void;
}

export const EditCourseLessonForm = (props: EditCourseLessonFormProps) => {
  const { event, closeDialog } = props;
  return (
    <EditForm2 resource="courseLessons" id={event.id} onSuccess={closeDialog}>
      <Box sx={{ minWidth: "450px" }}>
        <Column sx={{ gap: "20px" }}>
          <DateTimeInput allowPastDates source="start" size="small" />
          <LecturerInput source="lecturerId" size="small" />
          <RoomInput source="roomId" branchId={event.branchId} size="small" />
          <TextInput source="noteForParticipants" label="Hinweis für Teilnehmer" multiline rows={2} size="small" />
          <Row sx={{ justifyContent: "space-between" }}>
            <div />
            <SaveButton2 />
          </Row>
        </Column>
      </Box>
    </EditForm2>
  );
};
